import { Box, Card, CircularProgress, Grid, Icon, IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { Form, Formik, useFormikContext } from "formik";
import FormField from "layouts/pages/users/new-user/components/FormField";
import PropTypes from "prop-types";
import { useEffect, useState } from 'react';
import { errorAlert, successAlert } from "utils/Functions";
import { get, postNoResponse } from "utils/WebService";
import * as Yup from "yup";

export default function LawyersCreateEdit({ lawyerId, closeCreateEdit, refreshTable }) {
    const {
        nome,
        inscricao,
        seccional,
        subsessao,
        telefone,
        cep,
        logradouro,
        numero,
        complemento,
        uf,
        cidade,
        bairro } = configForm.formField;

    const [isLoadingInfo, setIsLoadingInfo] = useState(false)

    const handleSubmit = (values, actions) => {

        const body = {
            id: values.id,
            nome: values.nome,
            inscricao: values.inscricao,
            seccional: values.seccional,
            subsessao: values.subsessao,
            telefone: values.telefone,
            cep: values.cep,
            logradouro: values.logradouro,
            numeroEndereco: values.numero,
            complemento: values.complemento,
            estado: values.uf,
            cidade: values.cidade,
            bairro: values.bairro
        };

        postNoResponse("/lawyer/save", body)
            .then(() => {
                successAlert(!lawyerId ? "Advogado criado com sucesso!" : "Alterações salvas!", handleSucess());
            })
            .catch(() => {
                errorAlert(!lawyerId ? "Erro ao criar advogado!" : 'Erro ao salvar alterações.');
            })
            .finally(() => {
                actions.setSubmitting(false);
            });
    };

    function handleSucess() {
        closeCreateEdit()
        refreshTable()
    }

    return (
        <Card id="user-info">
            <Box display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h6">{lawyerId ? "Editar" : "Adicionar"} Advogado</MDTypography>
            </Box>
            <Formik
                initialValues={{
                    id: null,
                    nome: '',
                    inscricao: '',
                    seccional: '',
                    subsessao: '',
                    telefone: '',
                    cep: '',
                    logradouro: '',
                    numero: '',
                    complemento: '',
                    uf: '',
                    cidade: '',
                    bairro: ''
                }}
                validationSchema={clientValidations}
                onSubmit={(values, actions) => {
                    actions.setSubmitting(true);
                    handleSubmit(values, actions);
                }}>
                {({ values, errors, touched, isSubmitting, setFieldValue }) => {
                    return (
                        <Form id={configForm.formId} autoComplete="off">
                            <FetchAndSetData
                                lawyerId={lawyerId}
                                setIsLoadingInfo={setIsLoadingInfo}
                                closeCreateEdit={closeCreateEdit} />

                            <MDBox px={3}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={nome.type}
                                            label={nome.label}
                                            name={nome.name}
                                            value={values.nome ?? ""}
                                            placeholder={nome.placeholder}
                                            error={errors.nome?.length > 0 && touched.nome}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={inscricao.type}
                                            label={inscricao.label}
                                            name={inscricao.name}
                                            value={values.inscricao ?? ""}
                                            placeholder={inscricao.placeholder}
                                            error={errors.inscricao?.length > 0 && touched.inscricao}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={seccional.type}
                                            label={seccional.label}
                                            name={seccional.name}
                                            value={values.seccional ?? ""}
                                            placeholder={seccional.placeholder}
                                            error={errors.seccional?.length > 0 && touched.seccional}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={subsessao.type}
                                            label={subsessao.label}
                                            name={subsessao.name}
                                            value={values.subsessao ?? ""}
                                            placeholder={subsessao.placeholder}
                                            error={errors.subsessao?.length > 0 && touched.subsessao}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={telefone.type}
                                            label={telefone.label}
                                            name={telefone.name}
                                            value={values.telefone ?? ""}
                                            placeholder={telefone.placeholder}
                                            error={errors.telefone?.length > 0 && touched.telefone}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={cep.type}
                                            label={cep.label}
                                            name={cep.name}
                                            value={values.cep ?? ""}
                                            placeholder={cep.placeholder}
                                            error={errors.cep?.length > 0 && touched.cep}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={logradouro.type}
                                            label={logradouro.label}
                                            name={logradouro.name}
                                            value={values.logradouro ?? ""}
                                            placeholder={logradouro.placeholder}
                                            error={errors.logradouro?.length > 0 && touched.logradouro}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={numero.type}
                                            label={numero.label}
                                            name={numero.name}
                                            value={values.numero ?? ""}
                                            placeholder={numero.placeholder}
                                            error={errors.numero?.length > 0 && touched.numero}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={bairro.type}
                                            label={bairro.label}
                                            name={bairro.name}
                                            value={values.bairro ?? ""}
                                            placeholder={bairro.placeholder}
                                            error={errors.bairro?.length > 0 && touched.bairro}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={complemento.type}
                                            label={complemento.label}
                                            name={complemento.name}
                                            value={values.complemento ?? ""}
                                            placeholder={complemento.placeholder}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={cidade.type}
                                            label={cidade.label}
                                            name={cidade.name}
                                            value={values.cidade ?? ""}
                                            placeholder={cidade.placeholder}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={uf.type}
                                            label={uf.label}
                                            name={uf.name}
                                            value={values.uf ?? ""}
                                            placeholder={uf.placeholder}
                                        />
                                    </Grid>
                                </Grid>
                            </MDBox>

                            <Box display="flex" alignItems="center" justifyContent="end" p={2}>
                                <MDButton
                                    disabled={isLoadingInfo}
                                    size="large"
                                    variant="contained"
                                    color="info"
                                    circular={false}
                                    iconOnly={false}
                                    type="submit"
                                    endIcon={isSubmitting ?
                                        <CircularProgress
                                            color="inherit"
                                            size={20} sx={{ ml: 0, mr: 0 }} /> : null}>
                                    {!isSubmitting && (lawyerId ? "Salvar" : "Adicionar")}
                                </MDButton>
                            </Box>
                        </Form>)
                }}
            </Formik>
        </Card >
    );
};

const FetchAndSetData = ({ lawyerId, setIsLoadingInfo, closeCreateEdit }) => {
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        if (lawyerId) {
            setIsLoadingInfo(true);
            get(`/lawyer/by-id/${lawyerId}`).then(data => {
                const { id,
                    nome,
                    inscricao,
                    seccional,
                    subsessao,
                    telefone,
                    cep,
                    numeroEndereco,
                    logradouro,
                    complemento,
                    estado,
                    cidade,
                    bairro } = data;

                setFieldValue('id', id);
                setFieldValue('nome', nome);
                setFieldValue('inscricao', inscricao);
                setFieldValue('seccional', seccional);
                setFieldValue('subsessao', subsessao);
                setFieldValue('telefone', telefone);
                setFieldValue('cep', cep);
                setFieldValue('numero', numeroEndereco);
                setFieldValue('logradouro', logradouro);
                setFieldValue('complemento', complemento);
                setFieldValue('uf', estado);
                setFieldValue('cidade', cidade);
                setFieldValue('bairro', bairro);
                setIsLoadingInfo(false);
            }).catch(() => errorAlert("Advogado não encontrado!", closeCreateEdit));
        }
    }, [lawyerId]);

    return null;
};

export const configForm = {
    formId: "configuration-form",
    formField: {
        nome: {
            name: "nome",
            label: "Nome",
            type: "text",
            placeholder: "Informe o nome...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        inscricao: {
            name: "inscricao",
            label: "Inscrição",
            type: "text",
            placeholder: "Informe a inscrição...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        seccional: {
            name: "seccional",
            label: "Seccional",
            type: "text",
            placeholder: "Informe o seccional...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        subsessao: {
            name: "subsessao",
            label: "Subsessão",
            type: "text",
            placeholder: "Informe o subsessao...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        telefone: {
            name: "telefone",
            label: "Telefone",
            type: "text",
            placeholder: "Informe o telefone...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        cep: {
            name: "cep",
            label: "CEP",
            type: "text",
            placeholder: "Informe o cep...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        numero: {
            name: "numero",
            label: "Número",
            type: "text",
            placeholder: "Informe o numero...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        logradouro: {
            name: "logradouro",
            label: "Logradouro",
            type: "text",
            placeholder: "Informe o logradouro...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        complemento: {
            name: "complemento",
            label: "Complemento",
            type: "text",
            placeholder: "Informe o complemento..."
        },
        cidade: {
            name: "cidade",
            type: "text",
            label: "Cidade",
            placeholder: "Informe a cidade...",
        },
        uf: {
            name: "uf",
            type: "text",
            label: "Estado",
            placeholder: "Informe o estado...",
        },
        bairro: {
            name: "bairro",
            type: "text",
            label: "Bairro",
            placeholder: "Informe o bairro...",
        },
    }
}

const {
    formField: {
        nome,
        inscricao,
        seccional,
        subsessao,
        telefone,
        cep,
        numero,
        logradouro
    },
} = configForm;

export const clientValidations = Yup.object().shape({
    [nome.name]: Yup.string()
        .required(nome.errorMsg),
    [inscricao.name]: Yup.string()
        .required(inscricao.errorMsg),
    [seccional.name]: Yup.string()
        .required(seccional.errorMsg),
    [subsessao.name]: Yup.string()
        .required(subsessao.errorMsg),
    [telefone.name]: Yup.string()
        .required(telefone.errorMsg),
    [cep.name]: Yup.string()
        .required(cep.errorMsg),
    [numero.name]: Yup.string()
        .required(numero.errorMsg),
    [logradouro.name]: Yup.string()
        .required(logradouro.errorMsg),
});


LawyersCreateEdit.propTypes = {
    lawyerId: PropTypes.string,
    closeCreateEdit: PropTypes.func.isRequired,
};
